import * as React from 'react';
import { EventContext } from '../../../analytics/analytics';
import { ViewablityHandler } from '../../../viewability/viewabilityHandler';

interface AnalyticsData {
    event_category: string;
    event_action: string;
    event_label: string;
}

declare global {
    interface Window { mmClientApi: { push: (eventName: string, params: ViewablityHandler | AnalyticsData) => void } }
}


export const Link: React.FunctionComponent<React.HTMLProps<HTMLAnchorElement>> = ({ children, onClick, ...props }) => {
  const { category } = React.useContext(EventContext);
  const sendClickAnalytics = () => {
    if (typeof category !== 'undefined') {
      window.mmClientApi = window.mmClientApi || [];
      window.mmClientApi.push('analytics', {
        event_category: category,
        event_action: 'click',
        event_label: '',
      });
    }
  };

  const onClickHandler: React.EventHandler<any> = (...args) => {
    if (onClick) {
      onClick(...args);
    }
    sendClickAnalytics();
  };

  return <a {...props} onClick={onClickHandler}>{children}</a>;
};
